const UPDATE_CHECK_INTERVAL_MS = 60 * 1000;
const RELOAD_THROTTLE_MS = 30 * 1000;
const LAST_RELOAD_KEY = "cc4t_s3_last_release_reload";

let updateSWFn: ((reloadPage?: boolean) => Promise<void>) | null = null;
let registration: ServiceWorkerRegistration | undefined;
let updateCheckIntervalId: number | undefined;

const startPeriodicUpdateCheck = (): void => {
	if (updateCheckIntervalId !== undefined) {
		return;
	}

	updateCheckIntervalId = window.setInterval(() => {
		registration?.update().catch((err) => {
			console.warn("SW periodic update check failed:", err);
		});
	}, UPDATE_CHECK_INTERVAL_MS);
};

export const initServiceWorker = (): void => {
	void import("virtual:pwa-register").then(({ registerSW }) => {
		updateSWFn = registerSW({
			immediate: true,
			onNeedRefresh() {
				console.log("New version found, updating...");
				void updateSWFn?.(true);
			},
			onOfflineReady() {
				console.log("App ready to work offline");
			},
			onRegisteredSW(swUrl, reg) {
				console.log("SW registered:", swUrl, reg);
				registration = reg;
				startPeriodicUpdateCheck();
			},
			onRegisterError(error) {
				console.error("SW registration failed:", error);
			},
		});
	});
};

export const forceReloadForRelease = async (): Promise<void> => {
	const last = sessionStorage.getItem(LAST_RELOAD_KEY);
	if (last && Date.now() - Number(last) < RELOAD_THROTTLE_MS) {
		// Avoid reload loops when the backend is sustainedly down.
		return;
	}
	sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));

	try {
		await registration?.update();
	} catch (err) {
		console.warn("SW update failed before reload:", err);
	}

	window.location.reload();
};
